import * as React from 'react';


export default class Views extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
      <path d="M9.5 22H4V4H20V10" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M7 8H13.5828" stroke="#333333" strokeWidth="1.5" strokeLinecap="square"/>
		<path d="M7 12.75H8.59343" stroke="#333333" strokeWidth="1.5" strokeLinecap="square"/>
		<path d="M7 17.75H8.59343" stroke="#333333" strokeWidth="1.5" strokeLinecap="square"/>
		<circle cx="16" cy="17" r="5" stroke="#333333" strokeWidth="1.5"/>
		<path d="M19.5 20.5L22.5 23.5" stroke="#333333" strokeWidth="1.5" strokeLinecap="square"/>
      </svg>
    )
  }
}
